import {FC, useState, useEffect, Fragment} from 'react'

import {Link, useNavigate} from 'react-router-dom'

import AlertModal from './AlertModal'
import TermCondition from './TermCondition'

import Api from '../../../thesis-and-dissertations/helpers/api'

import './style.css'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import ComingSoonModal from '../MyPana/ComingSoonModal'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

const HomePage: FC = () => {
  const navigate = useNavigate()

  const [selectedCard, setSelectedCard] = useState(0)
  const [showAlertModal, setShowAlertModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [privacyPolicy, setPrivacyPolicy] = useState<any>({})

  useEffect(() => {
    getPrivacyPolice()

    let currentSelectedCard = localStorage.getItem('selectedCard')
    setSelectedCard(currentSelectedCard ? parseInt(currentSelectedCard) : 0)
  }, [])

  const handleSelected = (type: number) => {
    setSelectedCard(type)
  }

  const handleCloseAlert = (type: boolean) => {
    setShowAlertModal(type)
  }

  const handleCloseModal = (type: boolean) => {
    setShowModal(type)
  }

  const handleSelectedCard = () => {
    if (selectedCard === 2) {
      // saat pana sudah rilis hapus
      // setShowAlertModal(true)
      // setSelectedCard(0)
      // end modal pana coming soon

      // saat pana sudah rilis aktifkan checkpana
      checkPana()
      return
    }

    localStorage.setItem('alumniPage', 'talenta')
    navigate('/talenta-dashboard')
  }

  const checkPana = () => {
    setLoading(true)
    api
      .checkPana()
      .then((response: any) => {
        const {data} = response.data

        setLoading(false)
        if (!data?.status) {
          setShowAlertModal(true)
          setSelectedCard(0)
          return
        }

        localStorage.setItem('alumniPage', 'pana')
        navigate('/pana-beranda')
      })
      .catch((error: any) => {
        setLoading(false)
        handleApiError(error, navigate)
      })
  }

  const getPrivacyPolice = () => {
    api
      .getPrivacyPolicy()
      .then((response: any) => {
        const {data} = response.data
        setPrivacyPolicy(data)

        if (data?.is_agree) {
          setShowModal(false)
          return
        }

        setShowModal(true)
      })
      .catch(() => {
        setShowModal(false)
      })
  }

  const logout = () => {
    clearLocalStorageExcept([])
    window.location.href = '/auth'
  }

  return (
    <>
      {/* <ComingSoonModal showAlertModal={showAlertModal} handleCloseAlert={handleCloseAlert} /> */}

      {/* saat pana sudah rilis aktifkan AlertModal */}
      <AlertModal showAlertModal={showAlertModal} handleCloseAlert={handleCloseAlert} />

      <TermCondition
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        privacyPolicy={privacyPolicy}
      />

      <div className='container mt-15'>
        <div className='bg-white mt-15 p-15'>
          <p className='h6'>Pilih Jenis Pengguna</p>
          <p>Pilih jenis akun yang paling sesuai dengan Kebutuhan Anda saat ini</p>

          <div className='row mt-15 d-flex justify-content-center'>
            <div
              className='p-8 col-md-5 m-8'
              style={{
                boxShadow: '0px 4px 8px -2px #1018281A',
                background: `${selectedCard === 1 ? 'var(--Primary-L-400, #F9754C)' : ''}`,
                cursor: 'pointer',
              }}
              onClick={() => handleSelected(1)}
            >
              <div className='d-flex justify-content-start align-self-center'>
                <img
                  src={require('../../assets/img/job.png')}
                  alt='PANA'
                  id='avatar-image'
                  className='img-fluid'
                  style={{width: 'auto', height: '55px'}}
                />

                <div className='p-5'>
                  <p className={`h6 ${selectedCard === 1 ? 'text-white' : null}`}>
                    Lowongan Pekerjaan
                  </p>
                  <p className={`${selectedCard === 1 ? 'text-white' : null}`}>
                    Temukan peluang karir impian Anda
                  </p>
                </div>
              </div>
            </div>

            <div
              className='p-8 col-md-5 m-8'
              style={{
                boxShadow: '0px 4px 8px -2px #1018281A',
                background: `${selectedCard === 2 ? 'var(--Primary-L-400, #F9754C)' : ''}`,
                cursor: 'pointer',
              }}
              onClick={() => handleSelected(2)}
            >
              <div className='d-flex justify-content-start  align-self-center'>
                <img
                  src={require('../../assets/img/pana.png')}
                  alt='PANA'
                  id='avatar-image'
                  style={{width: 'auto', height: '55px'}}
                />

                <div className='p-5'>
                  <p className={`h6 ${selectedCard === 2 ? 'text-white' : null}`}>PANA</p>
                  <p className={`${selectedCard === 2 ? 'text-white' : null}`}>
                    Kembangkan potensi bakat Anda melalui program pengembangan Alumni
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className='container mt-5'>
            <div className='row justify-content-between mx-7 px-7'>
              {/* Tombol PILIH — tampil di atas saat mobile */}
              <div className='col-12 col-md-4 mb-3 order-1 order-md-2'>
                <button
                  className='btn btn-sm w-100 text-white p-3'
                  style={{backgroundColor: '#F95E2F', borderColor: '#F95E2F'}}
                  disabled={loading || selectedCard <= 0}
                  onClick={handleSelectedCard}
                >
                  {loading ? 'Loading...' : 'Pilih'}{' '}
                  <i className='fa fa-arrow-right ms-2 text-white' />
                </button>
              </div>

              {/* Tombol KELUAR AKUN — tampil di bawah saat mobile */}
              <div className='col-12 col-md-4 mb-3 order-2 order-md-1'>
                <button
                  className='btn btn-sm w-100 text-primary'
                  style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
                  onClick={logout}
                >
                  Keluar Akun <i className='fa fa-sign-out-alt ms-2 text-primary' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const Home: FC = () => {
  return <HomePage />
}

export default Home
